import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';

const SystemConfigurationGeneralRedirect = (): React.JSX.Element => (
	<ScreenRedirect to="/jira/settings/system/general-configuration" />
);

export default SystemConfigurationGeneralRedirect;
